import { createElement, formatTime, scrollToBottom } from './utils';
import { marked } from 'marked';
// import hljs from 'highlight.js';
// import 'highlight.js/styles/github.css';
import logo from '../../assets/jsimple-logo.png';
import { sendTicketInfo, GetCategories, GetClientSetupInfo, sendVerificationOtp, createChatUser, sendMessage, getPromtResult, GetAllActiveCategories } from './api';
import * as signalR from '@microsoft/signalr';

// Define SVG icons inline
// const chatIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//   <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
// </svg>`;

const chatIconSvg = `
    <svg fill="#ffffff" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
     width="800px" height="800px" viewBox="0 0 973.1 973.1" xml:space="preserve">
        <g>
            <path d="M502.29,788.199h-47c-33.1,0-60,26.9-60,60v64.9c0,33.1,26.9,60,60,60h47c33.101,0,60-26.9,60-60v-64.9
            C562.29,815,535.391,788.199,502.29,788.199z"/>
            <path d="M170.89,285.8l86.7,10.8c27.5,3.4,53.6-12.4,63.5-38.3c12.5-32.7,29.9-58.5,52.2-77.3c31.601-26.6,70.9-40,117.9-40
            c48.7,0,87.5,12.8,116.3,38.3c28.8,25.6,43.1,56.2,43.1,92.1c0,25.8-8.1,49.4-24.3,70.8c-10.5,13.6-42.8,42.2-96.7,85.9
            c-54,43.7-89.899,83.099-107.899,118.099c-18.4,35.801-24.8,75.5-26.4,115.301c-1.399,34.1,25.8,62.5,60,62.5h49
            c31.2,0,57-23.9,59.8-54.9c2-22.299,5.7-39.199,11.301-50.699c9.399-19.701,33.699-45.701,72.699-78.1
            C723.59,477.8,772.79,428.4,795.891,392c23-36.3,34.6-74.8,34.6-115.5c0-73.5-31.3-138-94-193.4c-62.6-55.4-147-83.1-253-83.1
            c-100.8,0-182.1,27.3-244.1,82c-52.8,46.6-84.9,101.8-96.2,165.5C139.69,266.1,152.39,283.5,170.89,285.8z"/>
        </g>
    </svg>  
`

const closeIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <line x1="18" y1="6" x2="6" y2="18"></line>
  <line x1="6" y1="6" x2="18" y2="18"></line>
</svg>`;

const sendIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <line x1="22" y1="2" x2="11" y2="13"></line>
  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
</svg>`;

const optionsIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="12" r="1"></circle>
  <circle cx="12" cy="5" r="1"></circle>
  <circle cx="12" cy="19" r="1"></circle>
</svg>`;


const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^[6-9]\d{9}$/;  // 10-digit number starting with 6-9

//For live chat
let isLiveChat = false;

let isAccept = false;

let guestId = "";
let guestName = "";
let guestEmail = "";
let agentName = "";
let typingTimeout;
// current chat With
let receiverEmail = "";
let connection; // Declare globally
let cat_Id;
let QuerycategoryName;
let adminResponseTimeout;

/**
 * UI module for the chatbot widget
 */
export class ChatbotUI {
    constructor(config) {
        this.config = {
            botName: 'AI Assistant',
            primaryColor: '#5c6bc0',
            position: 'left',
            welcomeMessage: '',
            type: '',  // ✅ Default value
            apiUrl: '',
            domain: '',
            emial: '',
            ...config
        };

        this.isOpen = false;
        this.elements = {};
        this.eventHandlers = {};

        this.selectedCategoryId = 0;
        this.selectedSubCategoryId = 0;
        this.userName = '';
        this.userID = 0;
        // this.isLiveChat=false;
        this.isSupportChat = false;
        this.isAskName = false;
        //for Creating User Through chat bot
        this.isAskForEmailDetails = false;
        this.isAskForNameDetails = false;
        this.isVerificationMessage = false;
        this.isVerified = false;
        this.isPermissionMessage = false;
        this.userContactInfo = '';
        this.isEmail = false;
        this.verficationOtp = '';
        this.lastThreeQuestions = [];

        //For categorisation 
        this.isautomatedCategorization = false;
        this.customerQuestion = '';
        this.isGeetingUserQuestion = false;

    }


    /**
     * Initializes the UI
     * @returns {Object} The created UI elements
     */
    init() {
        // Create main container
        this.elements.container = createElement('div', { className: `chatbot-widget chatbot-${this.config.position}` });

        // Create toggle button
        this.elements.toggleBtn = createElement('button', {
            className: 'chatbot-toggle-btn',
            ariaLabel: 'Toggle chatbot',
            innerHTML: chatIconSvg,
            onClick: () => this.toggleChat()
        });

        // Create chat window
        this.elements.window = createElement('div', { className: `chatbot-window chatbot-window-${this.config.position}` });

        // Create header
        this.elements.header = createElement('div', { className: 'chatbot-header' }, [
            createElement('div', { className: 'chatbot-title' }, this.config.botName),
            createElement('button', {
                className: 'chatbot-options-btn',
                ariaLabel: 'Chatbot options',
                innerHTML: optionsIconSvg
            })
        ]);

        // Create messages container
        this.elements.messages = createElement('div', { className: 'chatbot-messages' });

        // Create input container
        this.elements.inputContainer = createElement('div', { className: 'chatbot-input-container' }, [
            createElement('textarea', {
                className: 'chatbot-input',
                placeholder: 'Type a message...',
                rows: 1,
                onKeydown: (e) => this.handleInputKeydown(e),
                //onInput: (e) => this.handleInputTyping(e)
            }),
            createElement('button', {
                className: 'chatbot-send-btn',
                ariaLabel: 'Send message',
                innerHTML: sendIconSvg,
                onClick: () => this.handleSendClick()
            }),

            createElement('button', {
                className: 'chatlive-send-btn',
                ariaLabel: "Send message",
                id: "guest_chatlive",
                onclick: () => this.sendLiveChatMessage(),
                innerHTML: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">\n  <line x1="22" y1="2" x2="11" y2="13"></line>\n  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>\n</svg>',

            }),

        ]);

        // // Create footer with "Powered by Jsimple"
        // this.elements.footer = createElement('div', { className: 'chatbot-footer' }, [
        //     createElement('span', { 
        //         className: 'chatbot-powered-by' 
        //     }, 'powered by '),
        //     createElement('a', {
        //         className: 'chatbot-powered-link',
        //         href: 'https://jsimple.com',
        //         target: '_blank',
        //         rel: 'noopener noreferrer'
        //     }, 'Jsimple')
        // ]);

        // Create footer with "Powered by Jsimple" where "Jsimple" is an image
        this.elements.footer = createElement('div', { className: 'chatbot-footer' }, [
            createElement('span', {
                className: 'chatbot-powered-by'
            }, 'powered by '),
            createElement('a', {
                className: 'chatbot-powered-link',
                href: 'https://jsimple.com',
                target: '_blank',
                rel: 'noopener noreferrer'
            }, [
                createElement('img', {
                    src: logo, //'https://jsimple.com/assetsnew/img/logo-2.png',
                    alt: 'Jsimple',
                    className: 'chatbot-powered-logo'
                })
            ])
        ]);


        // Assemble the chat window
        this.elements.window.appendChild(this.elements.header);
        this.elements.window.appendChild(this.elements.messages);
        this.elements.window.appendChild(this.elements.inputContainer);
        this.elements.window.appendChild(this.elements.footer);

        // Add welcome message
        this.addWelcomeMessage();

        // Append elements to the container
        this.elements.container.appendChild(this.elements.toggleBtn);
        this.elements.container.appendChild(this.elements.window);

        // Apply custom styles
        this.applyCustomStyles();

        // Append container to the body
        document.body.appendChild(this.elements.container);

        return this.elements;
    }

    /**
     * Applies custom styles based on config
     */
    applyCustomStyles() {
        if (this.config.primaryColor) {
            const style = document.createElement('style');
            style.textContent = `
        :root {
          --chatbot-primary-color: ${this.config.primaryColor};
          --chatbot-primary-dark: ${this.darkenColor(this.config.primaryColor, 20)};
          --chatbot-primary-light: ${this.lightenColor(this.config.primaryColor, 20)};
        }
      `;
            document.head.appendChild(style);
        }
    }

    /**
     * Toggles the chat window open/closed
     */
    toggleChat() {
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
            this.elements.window.classList.add('active');
            this.elements.toggleBtn.innerHTML = closeIconSvg;
            this.elements.toggleBtn.setAttribute('aria-expanded', 'true');

            // Focus the input field
            setTimeout(() => {
                this.elements.inputContainer.querySelector('.chatbot-input').focus();
            }, 300);

            // Trigger onOpen event
            if (this.eventHandlers.onOpen) {
                this.eventHandlers.onOpen();
            }
        } else {
            this.elements.window.classList.remove('active');
            this.elements.toggleBtn.innerHTML = chatIconSvg;
            this.elements.toggleBtn.setAttribute('aria-expanded', 'false');

            // Trigger onClose event
            if (this.eventHandlers.onClose) {
                this.eventHandlers.onClose();
            }
        }
    }

    /**
     * Adds a welcome message
     */
    addWelcomeMessage() {
        const welcomeMessage = createElement('div', {
            className: 'chatbot-message bot'
        }, `${this.config.welcomeMessage}`);

        this.elements.messages.appendChild(welcomeMessage);
        // this.addSupportMessage();
    }


    saveCustomerMessage(message) {
        this.customerQuestion = message;
    }

    getAutoCategory() {


        GetAllActiveCategories().then(apiResponse => {

            const categoryResponse = apiResponse.data; // 👈 Extract 'data' from API response
            console.log(categoryResponse);
            const formattedCategories = categoryResponse.map(cat => {
                return `- ${cat.parentCategoryName}: ${cat.categoryName}: ${cat.catergoryId}`;
            }).join('\n');





             // 👉 Toggle this when AI is back
            const isAiWorking = false;



            if (!isAiWorking) {

        // ✅ Fallback: pick first category
        if (categoryResponse && categoryResponse.length > 0) {

            const firstCategory = categoryResponse[0];

            const parent_category = firstCategory.parentCategoryName;
            const child_category = firstCategory.categoryName;
            const category_id = firstCategory.catergoryId;

            console.log("Parent:", parent_category);
            console.log("Child:", child_category);
            console.log("ID:", category_id);

            this.selectedSubCategoryId = category_id;
            cat_Id = this.selectedSubCategoryId;
            QuerycategoryName = child_category;

            this.addSupportMessage();

        } else {
            console.warn("No categories found");
        }

        return; // ⛔ stop AI execution
    }
            // Build the prompt
            const promptText = `Your task is to categorize user queries.
                Given the following list of categories (Parent Category: Child Category: ID):

                [
                ${formattedCategories}
                ]

                Categorize the following user query into one Parent category and its most appropriate Child Category from the list. Return the result as a JSON object with 'parent_category', 'child_category', and 'category_id'.

                User Query:
                ${this.customerQuestion}`;
            // let promptText = `Your task is to categorize user queries.
            //     Given the following list of categories (Parent Category: Child Category: ID):

            //     [
            //     - Technical Support: Software Issue: 1
            //     - Technical Support: Hardware Issue: 2
            //     - Billing: Invoice Query: 3
            //     - Billing: Payment Problem: 4
            //     - General Inquiry: Product Information: 5
            //     - General Inquiry: Other: 6
            //     ]

            //     Categorize the following user query into one Parent category and its most appropriate Child Category from the list. Return the result as a JSON object with 'parent_category', 'child_category', and 'category_id'.

            //     User Query:
            //     ${this.customerQuestion}
            //     `;
            
            getPromtResult(promptText)
                .then(response => {
                    // Ensure response is parsed JSON with proper keys
                    const { parent_category, child_category, category_id } = response;

                    console.log("Parent:", parent_category);
                    console.log("Child:", child_category);
                    console.log("ID:", category_id);
                    this.selectedSubCategoryId = category_id;
                    cat_Id = this.selectedSubCategoryId;

                    QuerycategoryName = child_category;
                    //this.addSupportForm();
                    this.addSupportMessage();

                })
                .catch(error => {
                    console.error("Error:", error);
                });
        });


    }

    insertUser() {
        createChatUser(this.userName, this.userContactInfo, this.isEmail, this.config.type).then(response => {

            if (response.success) {
                this.userID = response.message;
                guestId = this.userID;
                this.addMessage("Verification successful! ", 'bot');
                // this.addSupportMessage();
                this.refraseQuestion();
                // this.addQuestionConfornMessage();
            } else {
                this.addMessage(response.message, 'bot');
            }

        });
    }
    sendVerifcationOtp() {
        sendVerificationOtp(this.userName, this.userContactInfo, this.isEmail).then(response => {

            if (response.success) {
                this.verficationOtp = response.message;
                // console.log(this.verficationOtp);
                this.addMessage(`Thanks ${this.userName.split(' ')[0]} for  providing your Details. <br><br> We have Sent an OTP on your contact. Please Check and Enter it here.`, 'bot');
                this.isVerificationMessage = true;
            } else {
                this.addMessage(response.message, 'bot');
            }

        });
    }
    checkDetailValidation(input) {
        input = input.trim();

        if (emailRegex.test(input)) {
            return { isValid: true, type: 'email' };
        } else if (phoneRegex.test(input)) {
            return { isValid: true, type: 'phone' };
        } else {
            return { isValid: false, type: null };
        }
    }

    addAskForUserDetails(chatHistory) {
        this.isSupportChat = true;
        this.lastThreeQuestions = chatHistory;

        if (this.isVerified) {
            this.refraseQuestion();
        } else {
            this.isAskForEmailDetails = true;
            this.addMessage("I couldn't find a direct answer to your question. Our team can definitely help! First, to get you the right support, I'll need to verify your identity. <br><br> Please provide either your email address or your phone number.", 'bot');
        }

    }
    addCustomerSupport(chathistory) {
        this.isSupportChat = true;
        this.lastThreeQuestions = chathistory
        // this.lastThreeQuestions.push({
        //     role: 'user',
        //     content: this.customerQuestion
        // });
        console.log('inside chathistory' + chathistory);
        if (this.isVerified) {
            //this.lastThreeQuestions = chathistory.slice(-3);

            this.refraseQuestion();
        } else {
            this.isAskForEmailDetails = true;
            this.addMessage("Alright, we’ll connect you to an agent. But first, please verify your identity. <br><br> Please provide either your email address or your phone number.", 'bot');
        }
    }
    addAskForUserName(contactinfo = '') {
        this.isAskForNameDetails = true;
        this.addMessage(`Thanks! I've recorded your ${contactinfo}.  <br><br> Could you please tell me your full name?`, 'bot');
    }
    addOtpResentMessage() {
        const message = createElement('div', {
            className: 'chatbot-message bot'
        }, "Hmm, that code doesn't seem to match - Please try again or request a new code!!");

        // Create buttons container
        const buttonsContainer = createElement('div', {
            className: 'chatbot-buttons'
        });


        const resendBtn = createElement('button', {
            className: 'chatbot-button chatbot-button--secondary',
            onclick: () => { this.addMessage('Resend', 'user'); this.sendVerifcationOtp(); }
        }, 'Resend');
        buttonsContainer.appendChild(resendBtn);

        message.appendChild(buttonsContainer);
        this.elements.messages.appendChild(message);
        scrollToBottom(this.elements.messages);

    }
    addOtpPermissionMessage(textmessage) {

        const permessage = createElement('div', {
            className: 'chatbot-message bot'
        }, textmessage);

        // Create buttons container
        const buttonsContainer = createElement('div', {
            className: 'chatbot-buttons'
        });


        const yesBtn = createElement('button', {
            className: 'chatbot-button chatbot-button--secondary',
            onclick: () => { this.addMessage('Yes', 'user'); this.sendVerifcationOtp(); }
        }, 'Yes');

        const noBtn = createElement('button', {
            className: 'chatbot-button chatbot-button--secondary p-0',
            onclick: () => {
                this.addMessage('No', 'user');
                this.addMessage('Alright, no worries. Is there anything else I can assist you with?', 'bot');
                this.isSupportChat = false;
            }
        }, 'No');

        buttonsContainer.appendChild(yesBtn);
        buttonsContainer.appendChild(noBtn);

        permessage.appendChild(buttonsContainer);
        this.elements.messages.appendChild(permessage);
        scrollToBottom(this.elements.messages);
    }

    /**
         *    add a Support message
         */
    addSupportMessage() {

        const supportMessage = createElement('div', {
            className: 'chatbot-message bot'
        }, "Would you like to contact support or talk to an live agent?");

        // Create buttons container
        const buttonsContainer = createElement('div', {
            className: 'chatbot-buttons'
        });


        //Call Api by passinf clientId/Type

        GetClientSetupInfo(this.config.type).then(response => {

            const {
                isSupportTicket,
                isLiveSupport,
                isPhoneSupport,
                isEmailSupport,
                isSmsSupport,
                phoneDetail,
                emailDetail,
                supportName,
                isAutomatedCategorization

            } = response;


            // Track created buttons
            const buttons = [];
            const customeBtn = [];

            if (isSupportTicket) {
                const chatButton = createElement('button', {
                    className: 'chatbot-button chatbot-button--secondary',
                    id: 'support-chat-btn',
                    onclick: () => this.addTicketTypeMessage()//this.addAskNameMessage()
                }, 'Contact Support');
                buttons.push(chatButton);
            }

        
            if (isLiveSupport) {
                const liveButton = createElement('button', {
                    className: 'chatbot-button chatbot-button--secondary p-0',
                    id: 'support-live-btn',
                    onclick: () => {
                        this.isLiveChat = true;

                        console.log('Live Chat Triggered');
                        // Add 'inactive-op' class to support-yes-btn
                        //document.getElementById('support-yes-btn').classList.add('inactive-op');

                        // Add 'active-op' class to support-live-btn
                        // document.getElementById('support-live-btn').classList.add('active-op');

                        // Hide chatbot-send-btn elements
                        document.querySelectorAll('.chatbot-send-btn').forEach(el => el.style.display = 'none');

                        // Show chatlive-send-btn elements
                        document.querySelectorAll('.chatlive-send-btn').forEach(el => el.style.display = 'block');

                        // Start the live chat connection
                        this.startConnection();
                    }
                }, 'Live Agent');
                buttons.push(liveButton);
            }

            if (isPhoneSupport) {
                // const phoneButton = createElement('button', {
                //     className: 'chatbot-button chatbot-button--secondary p-0',
                //     id: 'support-phone-btn',
                //     onclick: () => {
                //         // this.isPhoneSupport = true;
                //         this.addAddPhoneMessage(phoneDetail);
                //         console.log('Phone Support Triggered');
                //     }
                // }, 'Call Support');
                // buttons.push(phoneButton);
                customeBtn.push({ text: `📞 Reach Us by Phone`, action: () => { this.isSupportChat = false; this.addMessage(`${phoneDetail}`, 'bot') } });
            }
            if (isSmsSupport) {
                // const smsButton = createElement('button', {
                //     className: 'chatbot-button chatbot-button--secondary p-0',
                //     id: 'support-sms-btn',
                //     onclick: () => {
                //         // this.isEmailSupport = true;
                //         this.addAddSMSMessage('Prefer texting? Send ‘HELP’ to 12345, and we’ll respond shortly with assistance!');
                //         console.log('sms Support Triggered');
                //     }
                // }, 'SMS Support');
                // buttons.push(smsButton);
                customeBtn.push({ text: `📱 Reach via SMS`, action: () => { his.isSupportChat = false; this.addMessage(`Prefer texting? Send ‘HELP’ to 12345, and we’ll respond shortly with assistance!`, 'bot') } });
            }

            if (isEmailSupport) {
                // const emailButton = createElement('button', {
                //     className: 'chatbot-button chatbot-button--secondary p-0',
                //     id: 'support-email-btn',
                //     onclick: () => {
                //         // this.isEmailSupport = true;
                //         this.addAddEmailMessage(emailDetail);
                //         console.log('Email Support Triggered');
                //     }
                // }, 'Email Support');
                // buttons.push(emailButton);
                customeBtn.push({ text: `📧 Get in Touch with Us via Email`, action: () => { this.isSupportChat = false; this.addMessage(`${emailDetail}`, 'bot') } });
            }

            if (isAutomatedCategorization) {
                this.isautomatedCategorization = true;
            }

            // Append all buttons to container
            buttons.forEach(btn => buttonsContainer.appendChild(btn));
            if (customeBtn && customeBtn.length > 0) {
                this.addQuickActions(customeBtn);
            }
        });
        // Create Yes button with enhanced design
        // const yesButton = createElement('button', {
        //     className: 'chatbot-button chatbot-button--secondary',
        //     id: 'support-yes-btn', onClick: () => this.addAskNameMessage() //this.addTicketTypeMessage()
        // }, 'Contact Support');

        // Create No button with enhanced design
        // const noButton = createElement('button', {
        //     className: 'chatbot-button chatbot-button--secondary',
        //     id: 'support-no-btn'
        // }, 'No');

        // Create No button with enhanced design
        // const liveChatBtn = createElement('button', {
        //     className: 'chatbot-button chatbot-button--secondary p-0',
        //     id: 'support-live-btn',
        //     onclick: () => { isLiveChat = true; console.log(isLiveChat); }
        // }, 'Live agent');

        // Append buttons to container
        // buttonsContainer.appendChild(yesButton);
        // buttonsContainer.appendChild(noButton);
        // buttonsContainer.appendChild(liveChatBtn);


        // Append everything to message
        supportMessage.appendChild(buttonsContainer);
        this.elements.messages.appendChild(supportMessage);
        scrollToBottom(this.elements.messages);
    }




    addAskNameMessage() {
        // const ticketTypeMessage = createElement('div', {
        //     className: 'chatbot-message bot chatbot-option-container'
        // }, "Could you please tell me your name?");
        this.isAskName = true;
        this.isSupportChat = true;
        this.addMessage('Could you please tell me your name?', 'bot');
    }


    addAddPhoneMessage(phoneMessage) {


        this.addQuickActions([
            // { text: '📧 Check email for updates', action: () => this.addMessage('Please check your email for updates on your support request.', 'bot') },
            // { text: '💬 Continue chatting', action: () => this.addMessage('How else can I help you today?', 'bot') },
            { text: `📞 ${phoneMessage}`, action: () => this.addMessage(`For urgent issues, please call our support line ${phoneMessage}`, 'bot') }
        ]);
    }


    addAddEmailMessage(emailMessage) {
        this.addQuickActions([
            { text: `📧 ${emailMessage}`, action: () => this.addMessage(`Please contact us through email ${emailMessage}`, 'bot') },
        ]);
    }

    addAddSMSMessage(smsMessage) {
        this.addQuickActions([
            { text: `💬 Continue chatting`, action: () => this.addMessage(`${smsMessage}`, 'bot') },
        ]);
    }
    /**
       *    add a TicketType message
       */
    addTicketTypeMessage() {

        if (!this.isautomatedCategorization) {

            // Create the main message container
            const ticketTypeMessage = createElement('div', {
                className: 'chatbot-message bot chatbot-option-container'
            }, "What type of ticket would you like to raise?");

            // Create container for the buttons
            const optionsContainer = createElement('div', {
                className: 'chatbot-options-container'
            });


            // Call your API

            GetCategories(0).then(response => {
                const categories = response.data;  // Access the array inside the 'data' property
                if (Array.isArray(categories)) {
                    categories.forEach(category => {
                        const button = createElement('button', {
                            className: 'chatbot-option-button',
                            // onclick: () => this.submitTicketType(category.name, category.id)
                            onclick: () => {
                                // Disable this button
                                button.disabled = true;
                                button.classList.add('disabled'); // optional: for styling
                                this.selectedCategoryId = category.id;
                                this.addTicketSubTypeMessage(category.name, category.id);

                            }
                        }, category.name);
                        optionsContainer.appendChild(button);
                        scrollToBottom(this.elements.messages);
                    });
                } else {
                    console.error('Categories data is not an array:', categories);
                }
            }).catch(error => {
                console.error('Failed to load categories:', error);
                this.addMessage('Unable to load support categories at the moment.', 'bot');
            });




            // Append buttons to message
            ticketTypeMessage.appendChild(optionsContainer);

            // Add to chat
            this.elements.messages.appendChild(ticketTypeMessage);

            // Scroll to bottom
            scrollToBottom(this.elements.messages);
            this.isSupportChat = true;
        } else {
            // this.addSupportForm();
            this.addMessage('Customer Support', 'user');
            // this.getAutoCategory();

            let promptText = `Rephrase the sentence ${this.customerQuestion}, providing exactly 1 alternative version, and return it as 'rephrased_option' in JSON. Provide nothing else.`;
            getPromtResult(promptText)
                .then(response => {
                    try {
                        if (response && response.rephrased_option) {
                            this.customerQuestion = response.rephrased_option;
                            console.log("Rephrased:", response.rephrased_option);
                        } else {
                            console.warn("Unexpected response format:", response);
                        }
                    } catch (error) {
                        console.error("Error parsing response:", error);
                    }

                    this.addSupportForm();

                })
                .catch(error => {
                    console.error("API call failed:", error);
                });

            // this.addMessage('Can you conform you need support regarding <br><br>'+this.customerQuestion,'bot');

        }

    }
    refraseQuestion() {
        //  ${this.customerQuestion}
        // const combinedQuestions = this.lastThreeQuestions.map(q => q.content).join(' | ');
        const questions = Array.isArray(this.lastThreeQuestions)
            ? this.lastThreeQuestions
            : [this.lastThreeQuestions];

        const combinedQuestions = questions.map(q => q.content).join(' | ');

            const isAiWorking = false;


             if (!isAiWorking) {
        // ✅ Direct fallback response



    // 👉 Directly use original question (no AI call)
    this.customerQuestion = combinedQuestions;

    console.log("Using original question:", combinedQuestions);

    // 👉 Move to next step directly
    this.addQuestionConfornMessage();
    }

        // console.log('combine question ' + combinedQuestions);

        //         let promptText = `You are given a set of user questions separated by the "|" character. Combine them into a single, clear, and meaningful question that captures the essence of all three. Keep the output concise.If it's not possible to rephrase due to ambiguity or inconsistency, return "cannot rephrase"

        // Input: on ${combinedQuestions}

        // Output (in JSON format):
        // {{"rephrased_option": "<your rephrased question here or 'cannot rephrase'>"}}`;


//         let promptText = `You are given a set of user questions separated by the "|" character,ignore any general greetings or non-question phrases like "hi", "hello", "good morning", "thank you", "how are you", etc and ignore any general questions. From the remaining actual questions, Combine them into a single, clear, and meaningful question that captures the essence of all three. Keep the output concise.If it's not possible to rephrase due to ambiguity or inconsistency, return "cannot rephrase"

// Input: on ${combinedQuestions}

// Output (in JSON format):
// {{"rephrased_option": "<your rephrased question here or 'cannot rephrase'>"}}`;

        let promptText = `You are given a set of user questions separated by the "|" character,ignore any general greetings or non-question phrases like "hi", "hello", "good morning", "thank you", "how are you", etc and ignore any general questions.Do NOT expand, interpret, or change words. Do not rewrite the question.Only combine the provided terms/questions into one concise, meaningful question while preserving the exact original tokens. From the remaining actual questions, Combine them into a single, clear, and meaningful question that captures the essence of all three. Keep the output concise.If it's not possible to rephrase due to ambiguity or inconsistency, return "cannot rephrase" 
        
        Input: on ${combinedQuestions} 
        
        Output (in JSON format): {{"rephrased_option": "<your rephrased question here or 'cannot rephrase'>"}}`;




        // console.log(promptText);
        getPromtResult(promptText)
            .then(response => {
                try {
                    if (response && response.rephrased_option) {
                        this.customerQuestion = response.rephrased_option;

                        if (response.rephrased_option.toLowerCase() === 'cannot rephrase') {
                            this.addMessage('Unable to understant can you please describe you Question Clearly', 'bot');
                            this.isGeetingUserQuestion = true;
                        } else {
                            console.log("Rephrased:", response.rephrased_option);
                            this.addQuestionConfornMessage();
                        }

                        console.log("Rephrased:", response.rephrased_option);
                    } else {
                        console.warn("Unexpected response format:", response);
                    }
                } catch (error) {
                    console.error("Error parsing response:", error);
                }


            })
            .catch(error => {
                console.error("API call failed:", error);
            });
    }
    addQuestionConfornMessage() {
        const questionText = this.customerQuestion.replace(/\n/g, '<br>');
        const askConformQues = createElement('div', {
            className: 'chatbot-message bot'
        }, []);
        askConformQues.innerHTML = `Can you confirm you need support regarding :- ${questionText}`;
        // Create buttons container
        const buttonsContainer = createElement('div', {
            className: 'chatbot-buttons'
        });


        const yesBtn = createElement('button', {
            className: 'chatbot-button chatbot-button--secondary',
            onclick: () => { this.addMessage('Yes', 'user'); this.getAutoCategory(); }
        }, 'Yes');

        const noBtn = createElement('button', {
            className: 'chatbot-button chatbot-button--secondary p-0',
            onclick: () => {
                this.addMessage('No', 'user');
                this.addMessage('Please describe you Question Clearly', 'bot');
                this.isGeetingUserQuestion = true;
            }
        }, 'No');

        buttonsContainer.appendChild(yesBtn);
        buttonsContainer.appendChild(noBtn);

        askConformQues.appendChild(buttonsContainer);
        this.elements.messages.appendChild(askConformQues);
        scrollToBottom(this.elements.messages);
    }


    addTicketSubTypeMessage(selectedValue, id) {

        if (!selectedValue) return; // Ignore if default option is selecte

        this.addMessage(selectedValue, 'user');
        // Create the main message container
        const ticketTypeMessage = createElement('div', {
            className: 'chatbot-message bot chatbot-option-container'
        }, "Please select the most relatabale option ?");

        // Create container for the buttons
        const optionsContainer = createElement('div', {
            className: 'chatbot-options-container'
        });


        // Call your API

        GetCategories(id).then(response => {
            const categories = response.data;  // Access the array inside the 'data' property
            if (Array.isArray(categories)) {
                categories.forEach(category => {
                    const button = createElement('button', {
                        className: 'chatbot-option-button',
                        onclick: () => {
                            // Disable this button
                            button.disabled = true;
                            button.classList.add('disabled'); // optional: for styling
                            this.selectedSubCategoryId = category.id;

                            // this.submitTicketType(category.name, category.id);
                            this.addSupportForm();
                        }

                    }, category.name);
                    optionsContainer.appendChild(button);
                    scrollToBottom(this.elements.messages);
                });
            } else {
                console.error('Categories data is not an array:', categories);
            }
        }).catch(error => {
            console.error('Failed to load categories:', error);
            this.addMessage('Unable to load support categories at the moment.', 'bot');
        });




        // Append buttons to message
        ticketTypeMessage.appendChild(optionsContainer);

        // Add to chat
        this.elements.messages.appendChild(ticketTypeMessage);
        scrollToBottom(this.elements.messages);
        // Scroll to bottom
        // this.elements.messages.scrollTop = this.elements.messages.scrollHeight;

    }


    addSupportForm() {
        console.log(this.customerQuestion);
        const supportForm = createElement('div', {
            className: 'chatbot-message bot support-form-container'
        }, [
            createElement('div', { className: 'support-form-header' }, 'Help & Support'),
            createElement('form', {
                className: 'support-form',
                onSubmit: (e) => this.handleSupportSubmit(e)
            }, [
                // // Name field
                // createElement('div', { className: 'form-field' }, [
                //     createElement('input', {
                //         type: 'text',
                //         id: 'support-name',
                //         name: 'support-name',
                //         className: 'form-input-chatbot',
                //         required: true,
                //         placeholder: ' '
                //     }),
                //     createElement('label', {
                //         htmlFor: 'support-name',
                //         className: 'form-label'
                //     }, 'Subject')
                // ]),

                // // Subject field
                // createElement('div', { className: 'form-field' }, [
                //     createElement('select', {
                //         id: 'support-subject',
                //         name: 'support-subject',
                //         className: 'form-select',
                //         required: true
                //     }, [
                //         createElement('option', { value: '' }, ''),
                //         createElement('option', { value: 'technical' }, 'Technical Issue'),
                //         createElement('option', { value: 'billing' }, 'Billing Question'),
                //         createElement('option', { value: 'feature' }, 'Feature Request'),
                //         createElement('option', { value: 'other' }, 'Other')
                //     ]),
                //     createElement('label', {
                //         htmlFor: 'support-subject',
                //         className: 'form-label'
                //     }, 'Subject')
                // ]),

                // Priority field
                createElement('div', { className: 'form-field' }, [
                    createElement('select', {
                        id: 'support-priority',
                        name: 'support-priority',
                        className: 'form-select-chatbot',
                        required: true
                    }, [
                        // createElement('option', { value: '' }, ''),
                        createElement('option', { value: 'L', selected: true }, 'Low'), // Default selected
                        createElement('option', { value: 'M' }, 'Medium'),
                        createElement('option', { value: 'H' }, 'High'),
                        createElement('option', { value: 'U' }, 'Urgent')
                    ]),
                    createElement('label', {
                        htmlFor: 'support-priority',
                        className: 'form-label'
                    }, 'Priority')
                ]),

                // Message field
                createElement('div', { className: 'form-field form-field-textarea' }, [
                    createElement('textarea', {
                        id: 'support-message',
                        name: 'support-message',
                        className: 'form-textarea-chatbot',
                        required: true,
                        placeholder: ' ',
                        rows: 4,
                        value: this.customerQuestion

                    }),
                    createElement('label', {
                        htmlFor: 'support-message',
                        className: 'form-label'
                    }, 'Describe your issue')
                ]),

                // File upload field
                createElement('div', { className: 'form-field form-field-file' }, [
                    createElement('input', {
                        type: 'file',
                        id: 'support-file',
                        name: 'support-file',
                        className: 'form-file-input',
                        multiple: true,
                        accept: '.jpg,.jpeg,.png,.pdf,.doc,.docx'
                    }),
                    createElement('label', {
                        For: 'support-file',
                        className: 'form-file-label'
                    }, [
                        createElement('span', { className: 'file-icon' }, '📎'),
                        createElement('span', { className: 'file-text' }, 'Attach files (optional)')
                    ]),
                    createElement('div', { className: 'file-list', id: 'file-list' })
                ]),



                // Form actions
                createElement('div', { className: 'form-actions' }, [
                    createElement('button', {
                        type: 'button',
                        className: 'btn-chatbot btn-chatbot-secondary',
                        onClick: () => this.closeSupportForm()
                    }, 'Cancel'),
                    createElement('button', {
                        type: 'submit',
                        className: 'btn-chatbot btn-chatbot-primary'
                    }, [
                        createElement('span', { className: 'btn-chatbot-text' }, 'Submit'),
                        createElement('div', { className: 'btn-chatbot-ripple' })
                    ])
                ])
            ]),
            createElement('div', {
                className: 'chatbot-message-time'
            }, formatTime(new Date()))
        ]);

        this.elements.messages.appendChild(supportForm);

        scrollToBottom(this.elements.messages);

        // Add file upload handler
        this.setupFileUpload();

        return supportForm;
    }

    // // Setup file upload functionality
    setupFileUpload() {
        const fileInput = document.getElementById('support-file');
        const fileList = document.getElementById('file-list');

        if (!fileInput || !fileList) return;

        fileInput.addEventListener('change', (e) => {
            fileList.innerHTML = '';
            Array.from(e.target.files).forEach((file, index) => {
                const fileItem = createElement('div', { className: 'file-item' }, [
                    createElement('span', { className: 'file-name' }, file.name),
                    createElement('span', { className: 'file-size' }, this.formatFileSize(file.size)),
                    createElement('button', {
                        type: 'button',
                        className: 'file-remove',
                        onClick: () => this.removeFile(index)
                    }, '×')
                ]);
                fileList.appendChild(fileItem);
            });
        });
    }


    // Enhanced form submission with better feedback
    handleSupportSubmit(e) {
        e.preventDefault();

        const form = e.target;
        const submitBtn = form.querySelector('.btn-chatbot-primary');
        const btnText = submitBtn.querySelector('.btn-chatbot-text');

        const supportFileInput = document.getElementById('support-file');
        const files = supportFileInput.files;

        // Validate form
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        // Show loading state
        submitBtn.classList.add('loading');
        submitBtn.disabled = true;
        btnText.textContent = 'Submitting...';

        // const formData = new FormData(form);
        const formData = new FormData();

        //  const supportData = {
        //         // ticketId: this.generateTicketId(),
        //         parentCatergoryId: parseInt(this.selectedCategoryId),
        //         categoryId: parseInt(this.selectedSubCategoryId),
        //         // subject: formData.get('support-name'),
        //         descr: formData.get('support-message'),
        //         Prority:formData.get('support-priority'),
        //         attachment: null // or base64 if needed

        //      };

        // Append supportData as individual fields
        formData.append('parentCatergoryId', parseInt(this.selectedCategoryId));
        formData.append('categoryId', parseInt(this.selectedSubCategoryId));
        formData.append('descr', document.getElementById('support-message').value);
        formData.append('prority', document.getElementById('support-priority').value);
        formData.append('clientId', parseInt(this.config.type));
        formData.append('userId', parseInt(this.userID));
        formData.append('userName', this.userName);

        // Append files to 'attachments'
        for (let i = 0; i < files.length; i++) {
            formData.append('attachments', files[i]);
        }

        // Simulate API call with realistic delay
        setTimeout(() => {
            // Remove form with fade out animation
            const formContainer = form.closest('.support-form-container');
            formContainer.style.transition = 'all 0.3s ease-out';
            formContainer.style.opacity = '0';
            formContainer.style.transform = 'translateY(-10px)';

            // sendTicketInfo(supportData);
            sendTicketInfo(formData).then(() => {
                try {
                    bindTicketGrid();
                } catch (error) {
                    console.error("Error in bindTicketGrid:", error);
                }
            }).catch((error) => {
                console.error("Error in sendTicketInfo:", error);
            });
            setTimeout(() => {
                formContainer.remove();
                this.showSuccessMessage('Thank you! Your support request has been submitted successfully. Our team will respond within 24 hours.');

                // Show follow-up options
                setTimeout(() => {
                    this.addQuickActions([
                        { text: '📧 Check email for updates', action: () => this.addMessage('Please check your email for updates on your support request.', 'bot') },
                        { text: '💬 Continue chatting', action: () => this.addMessage('How else can I help you today?', 'bot') },
                        { text: '📞 Need urgent help?', action: () => this.addMessage('For urgent issues, please call our support line at +1-800-SUPPORT', 'bot') }
                    ]);
                }, 1000);
            }, 300);

            // Log submission (replace with actual API call)
            // console.log('Support form submitted:', supportData);

        }, 2000);

        this.isSupportChat = false;
    }
    // Show success message with animation
    showSuccessMessage(message) {
        const successMsg = createElement('div', {
            className: 'chatbot-message bot success-message',
            style: {
                background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)',
                border: '2px solid #4caf50',
                borderRadius: '16px',
                padding: '16px 20px',
                margin: '16px 0',
                opacity: '0',
                transform: 'translateY(20px)',
                transition: 'all 0.5s ease-out'
            }
        }, [
            createElement('div', {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                }
            }, [
                createElement('span', {
                    style: {
                        fontSize: '24px'
                    }
                }, '✅'),
                createElement('span', {
                    style: {
                        color: '#2e7d32',
                        fontWeight: '500',
                        fontSize: '15px'
                    }
                }, message)
            ]),
            createElement('div', {
                className: 'chatbot-message-time'
            }, formatTime(new Date()))
        ]);

        this.elements.messages.appendChild(successMsg);

        // Trigger animation
        setTimeout(() => {
            successMsg.style.opacity = '1';
            successMsg.style.transform = 'translateY(0)';
        }, 100);

        scrollToBottom(this.elements.messages);
    }

    closeSupportForm() {
        const formContainer = document.querySelector('.support-form-container');
        if (formContainer) {
            formContainer.style.transition = 'all 0.3s ease-out';
            formContainer.style.opacity = '0';
            formContainer.style.transform = 'translateY(-10px)';
            setTimeout(() => formContainer.remove(), 300);
        }

        setTimeout(() => {
            this.addMessage('Support form cancelled. How else can I help you?', 'bot');
        }, 400);

        this.isSupportChat = false;
    }
    // Enhanced quick actions
    addQuickActions(actions) {
        const quickActions = createElement('div', {
            className: 'chatbot-message bot quick-actions-container',
            style: {
                opacity: '0',
                transform: 'translateY(20px)',
                transition: 'all 0.5s ease-out'
            }
        }, [
            createElement('div', { className: 'quick-actions' },
                actions.map(action =>
                    createElement('button', {
                        className: 'quick-action-btn',
                        onClick: () => {
                            action.action();
                            // Remove quick actions after selection with animation
                            const container = document.querySelector('.quick-actions-container');
                            if (container) {
                                container.style.opacity = '0';
                                container.style.transform = 'translateY(-10px)';
                                setTimeout(() => container.remove(), 300);
                            }
                        }
                    }, action.text)
                )
            ),
            createElement('div', {
                className: 'chatbot-message-time'
            }, formatTime(new Date()))
        ])
        this.elements.messages.appendChild(quickActions)
        // Trigger animation
        setTimeout(() => {
            quickActions.style.opacity = '1';
            quickActions.style.transform = 'translateY(0)';
        }, 100)
        scrollToBottom(this.elements.messages);
    }


    // Helper methods
    formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    removeFile(index) {
        const fileInput = document.getElementById('support-file');
        if (!fileInput) return;

        const dt = new DataTransfer();
        const files = Array.from(fileInput.files);

        files.splice(index, 1);
        files.forEach(file => dt.items.add(file));

        fileInput.files = dt.files;
        fileInput.dispatchEvent(new Event('change'));
    }



    /**
     * Adds a message to the chat
     * @param {string} text - The message text
     * @param {string} sender - The message sender ('bot' or 'user')
     */
    addMessage(text, sender = 'bot') {
        const messageContent = createElement('div', {
            className: `chatbot-message-content-${sender}`
        });

        // Apply marked for markdown rendering
        messageContent.innerHTML = marked.parse(text);

        const codeBlocks = messageContent.querySelectorAll('pre code');
        // codeBlocks.forEach(block => {
        //     hljs.highlightElement(block);
        // });

        const messageTime = createElement('div', {
            className: 'chatbot-message-time'
        }, formatTime(new Date()));

        const message = createElement('div', {
            className: `chatbot-message ${sender}`
        });

        message.appendChild(messageContent);
        message.appendChild(messageTime);

        this.elements.messages.appendChild(message);
        scrollToBottom(this.elements.messages);

        return message;
    }

    /**
     * Shows the typing indicator
     */
    showTypingIndicator() {
        // Remove existing typing indicator if any
        this.hideTypingIndicator();

        const typingIndicator = createElement('div', { className: 'chatbot-typing' }, [
            createElement('div', { className: 'chatbot-typing-dot' }),
            createElement('div', { className: 'chatbot-typing-dot' }),
            createElement('div', { className: 'chatbot-typing-dot' })
        ]);

        this.elements.typingIndicator = typingIndicator;
        this.elements.messages.appendChild(typingIndicator);
        scrollToBottom(this.elements.messages);
    }

    /**
     * Hides the typing indicator
     */
    hideTypingIndicator() {
        if (this.elements.typingIndicator) {
            this.elements.typingIndicator.remove();
            this.elements.typingIndicator = null;
        }
    }

    /**
     * Handles the send button click
     */
    handleSendClick() {
        const input = this.elements.inputContainer.querySelector('.chatbot-input');
        const message = input.value.trim();

        if (message) {
            // Trigger onSendMessage event
            if (this.isSupportChat) {
                if (this.isAskName) {
                    this.addMessage(message, 'user');
                    this.userName = message;
                    this.isAskName = false;
                    this.addTicketTypeMessage();

                    this.clearTextBox(input);
                }
                else if (this.isAskForEmailDetails) {
                    this.addMessage(message, 'user');
                    var result = this.checkDetailValidation(message);
                    if (result.isValid) {
                        this.isAskForEmailDetails = false;
                        this.addAskForUserName(result.type);
                        this.userContactInfo = message;
                        guestEmail = message;
                        this.isEmail = result.type === 'email';
                    } else {
                        this.isAskForEmailDetails = true;
                        this.addMessage("Sorry, the contact info you entered doesn't look valid. Please enter a valid email or 10-digit phone number.", 'bot');

                    }
                    this.clearTextBox(input);
                }
                else if (this.isAskForNameDetails) {
                    this.addMessage(message, 'user');
                    if (message === '') {
                        this.isAskForNameDetails = true;
                        this.addMessage("Name cannot be blank. Kindly enter your full name to proceed.", 'bot');
                    } else {
                        this.isAskForNameDetails = false;
                        this.userName = message;
                        guestName = message;
                        // this.addMessage(`Thanks, ${this.userName.split(' ')[0]}! To complete the verification, can I send you a one-time password (OTP) to ${this.contactinfo} linked to your account. ? `, 'bot');
                        // this.sendVerifcationOtp();
                        this.addOtpPermissionMessage(`Thanks, ${this.userName.split(' ')[0]}! To complete the verification, can I send you a one-time password (OTP) to ${this.userContactInfo} linked to your account. ? `);
                    }
                    this.clearTextBox(input);
                } else if (this.isVerificationMessage) {

                    if (this.verficationOtp === message) {
                        this.addMessage(message, 'user');
                        this.isVerificationMessage = false;
                        this.isVerified = true;
                        this.insertUser();
                        // this.addSupportMessage();
                    } else {
                        this.addMessage(message, 'user');
                        // this.addMessage("Hmm, that code doesn't seem to match - Please try again or request a new code!!", 'bot');
                        this.addOtpResentMessage();
                        this.isVerificationMessage = true;
                    }
                    this.clearTextBox(input);
                } else if (this.isGeetingUserQuestion) {
                    this.addMessage(message, 'user');
                    this.customerQuestion = message;
                    this.isGeetingUserQuestion = false;
                    this.addMessage('All right i have recorded your question....', 'bot');
                    this.getAutoCategory();
                    // this.addSupportMessage();
                    this.clearTextBox(input);
                }
                return;
            }

            if (this.eventHandlers.onSendMessage) {
                this.eventHandlers.onSendMessage(message);
            }

            // Clear input
            input.value = '';
            input.style.height = 'auto';
            input.focus();
        }
    }


    clearTextBox(input) {
        // Clear input
        input.value = '';
        input.style.height = 'auto';
        input.focus();
    }
    /**
     * Handles keydown events in the input field
     * @param {Event} event - The keydown event
     */
    handleInputKeydown(event) {
        const input = event.target;

        // Auto-resize textarea
        setTimeout(() => {
            input.style.height = 'auto';
            input.style.height = Math.min(input.scrollHeight, 100) + 'px';
        }, 0);

        // Send message on Enter (without Shift)
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            if (this.isLiveChat) {
                document.querySelector('.chatlive-send-btn').click();
                console.log('livechat buttton is called');
            } else {
                this.handleSendClick();
            }
        }

        console.log(receiverEmail +" Receiver "+" "+ this.isLiveChat+"Is LiveChat");

         if (!receiverEmail || !this.isLiveChat) return;
    
            console.log('typing.........');
            connection.invoke("UserTyping", guestEmail, receiverEmail)
                .catch(err => console.error(err.toString()));

            clearTimeout(typingTimeout);
            typingTimeout = setTimeout(() => {
                connection.invoke("UserStoppedTyping", guestEmail, receiverEmail)
                    .catch(err => console.error(err.toString()));
            }, 1000); // 1 sec after last keypress
    }

    /**
     * Registers an event handler
     * @param {string} event - The event name
     * @param {Function} handler - The event handler
     */
    on(event, handler) {
        this.eventHandlers[`on${event.charAt(0).toUpperCase() + event.slice(1)}`] = handler;
    }

    /**
     * Lightens a color by a percentage
     * @param {string} color - The color to lighten
     * @param {number} percent - The percentage to lighten by
     * @returns {string} The lightened color
     */
    lightenColor(color, percent) {
        const num = parseInt(color.replace('#', ''), 16);
        const amt = Math.round(2.55 * percent);
        const R = (num >> 16) + amt;
        const G = (num >> 8 & 0x00FF) + amt;
        const B = (num & 0x0000FF) + amt;

        return '#' + (
            0x1000000 +
            (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
            (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
            (B < 255 ? B < 1 ? 0 : B : 255)
        ).toString(16).slice(1);
    }

    /**
     * Darkens a color by a percentage
     * @param {string} color - The color to darken
     * @param {number} percent - The percentage to darken by
     * @returns {string} The darkened color
     */
    darkenColor(color, percent) {
        const num = parseInt(color.replace('#', ''), 16);
        const amt = Math.round(2.55 * percent);
        const R = (num >> 16) - amt;
        const G = (num >> 8 & 0x00FF) - amt;
        const B = (num & 0x0000FF) - amt;

        return '#' + (
            0x1000000 +
            (R > 0 ? R : 0) * 0x10000 +
            (G > 0 ? G : 0) * 0x100 +
            (B > 0 ? B : 0)
        ).toString(16).slice(1);
    }


    //for live chat
    startConnection() {
        const self = this; // capture the correct `this`
        const container = document.querySelector(".chatbot-messages");
        connection = new signalR.HubConnectionBuilder()
            .withUrl(`/chathub?userId=${encodeURIComponent(guestId)}&username=${encodeURIComponent(guestName)}&email=${encodeURIComponent(guestEmail)}&isBot=${true}&categoryId=${encodeURIComponent(cat_Id)}&userMessage=${encodeURIComponent(this.customerQuestion)}&categoryName=${encodeURIComponent(QuerycategoryName)}`)
            .build();

            

        connection.on("ShowTypingIndicator", function(guestEmail) {
            const currentReceiver =  receiverEmail;
            if (guestEmail === currentReceiver) {
               self.showTypingIndicator();
            }
        });

        connection.on("HideTypingIndicator", function(guestEmail) {
            const currentReceiver = receiverEmail;
            if (guestEmail === currentReceiver) {
                 self.hideTypingIndicator();
            }
        });


           connection.on("CustomerChatEnd", function (count, disconnectedEmail) {
            // console.log("outside the  if");
            // console.log("guestemail"+ guestEmail);
            // console.log("diconnect "+disconnectedEmail);
            if (guestEmail == disconnectedEmail) {
                 console.log("inside the disconnect");
                const queueHtml = `
                    <div class="connect-to-live text-center fs-5" style="padding: 6px;background: #d3d3d38c;">
                        ${agentName} has ended the chat.
                    </div>`;
                    document.querySelector('.chatbot-messages').insertAdjacentHTML('beforeend', queueHtml);

                    // Scroll manually
                    const chatMessages = document.querySelector('.chatbot-messages');
                    chatMessages.scrollTop = chatMessages.scrollHeight;

                    self.isLiveChat = false;
                    console.log("inside the disconnect done");
            }

        });

        connection.on("ReceiveMessage", function (senderName, senderEmail, isPicked, message) {
            const messageHtml = `
            <div class="chatbot-message bot">
                <div class="chatbot-message-content-bot">
                    <p>${message}</p>
                </div>
                <div class="chatbot-message-time">${new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}</div>
            </div>`;
            document.querySelector('.chatbot-messages').insertAdjacentHTML('beforeend', messageHtml);
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        });

        let isAlreadyRe = true;
        let isAdminlive = true;

       

        connection.on("UpdateUserList", function (users) {
            let index = 1;
            let grade = 'th';
            if (isAccept) return;

            users.forEach(user => {
                if (!user.isPicked && user.isBot) {
                    if (index == 1) {
                        grade = 'st';
                    } else if (index == 2) {
                        grade = 'nd';
                    } else if (index == 3) {
                        grade = 'rd';
                    } else {
                        grade = 'th';
                    }
                    // index++;
                }
                if (user.email === guestEmail && user.isPicked && !isAccept && isAdminlive) {
                    
                    const currentTime = new Date().toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    });

                    // Remove any existing "connect-to-live" message
                    document.querySelectorAll('.chatbot-messages .connect-to-live').forEach(el => el.remove());
                    agentName = user.acceptedName;
                    // Add connection success message
                    const connectedHtml = `
                    <div class="connected-to-agent text-center fs-5" style="padding: 6px;background: #d3d3d38c;">
                        <p>${user.acceptedName} has joined the live chat.</p>
                    </div>`;
                    document.querySelector('.chatbot-messages').insertAdjacentHTML('beforeend', connectedHtml);
                    clearTimeout(adminResponseTimeout);
                    // Fetch chat history using fetch instead of $.get
                    fetch(`/api/livechat/history?user1=${encodeURIComponent(guestEmail)}&user2=${encodeURIComponent(user.acceptedEmail)}`)
                        .then(res => res.json())
                        .then(messages => {
                            messages.forEach(msg => {
                                const isSentByAgent = msg.senderEmail === guestEmail;
                                const msgDiv = document.createElement('div');
                                msgDiv.className = `message ${isSentByAgent ? "chatbot-message user" : "chatbot-message bot"}`;
                                msgDiv.innerHTML = `
                                <div class="${isSentByAgent ? "chatbot-message-content-user" : "chatbot-message-content-bot"}">
                                    ${msg.message}
                                </div>
                                <div class="chatbot-message-time">${currentTime}</div>`;
                                document.querySelector('.chatbot-messages').appendChild(msgDiv);
                            });

                            // Append default agent greeting
                            const greetHtml = `
                            <div class="chatbot-message bot">
                                <div class="chatbot-message-content-bot">
                                    <p>hi there how can i help you?</p>
                                </div>
                                <div class="chatbot-message-time">${currentTime}</div>
                            </div>`;
                            document.querySelector('.chatbot-messages').insertAdjacentHTML('beforeend', greetHtml);

                            if (container) {
                                container.scrollTop = container.scrollHeight;
                            }
                        });

                    if (container) {
                        container.scrollTop = container.scrollHeight;
                    }
                    receiverEmail = user.acceptedEmail;
                    isAdminlive = false;

                } else if (user.email === guestEmail && isAlreadyRe) {
                    const currentTime = new Date().toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    });

                    const queueHtml = `
                    <div class="connect-to-live text-center fs-5" style="padding: 6px;background: #d3d3d38c;">
                        You are ${index}${grade} in line.
                    </div>`;
                    document.querySelector('.chatbot-messages').insertAdjacentHTML('beforeend', queueHtml);

                    // Scroll manually
                    const chatMessages = document.querySelector('.chatbot-messages');
                    chatMessages.scrollTop = chatMessages.scrollHeight;

                    isAlreadyRe = false;
                    self.onUserRequestToAdmin();
                    index++;
                }
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }

                if (user.isAccept && user.isBot) {
                    setTimeout(() => {
                        this.addMessage("Time Out ", 'bot');
                    }, 5000); // completes in 5 seconds
                }

            });
            // Scroll manually
            const chatMessages = document.querySelector('.chatbot-messages');
            chatMessages.scrollTop = chatMessages.scrollHeight;
            //  this.scrollToBottomLive();

        });

        connection.onreconnected(() => {
            console.log("Reconnected, refreshing user list...");
            connection.invoke("RequestUserList").catch(err => console.error("RequestUserList (reconnect) failed:", err));
        });

        if (connection.state === signalR.HubConnectionState.Disconnected) {
            connection.start()
                .then(() => {
                    console.log("✅ SignalR connected.");
                    connection.invoke("RequestUserList").catch(err => console.error("RequestUserList (initial) failed:", err));
                })
                .catch(err => {
                    console.error("Connection failed:", err.toString());
                });
        } else {
            console.log("⚠️ SignalR already connected or connecting. Current state:", connection.state);
        }

       

    }


  handleInputTyping(e) {
   
}


    onUserRequestToAdmin() {
        clearTimeout(adminResponseTimeout);
        let self = this;
        adminResponseTimeout = setTimeout(function () {
            connection.invoke("ForceDisconnectUser", guestEmail).catch(err => console.error("Disconnect failed:", err));
            document.querySelectorAll('.chatbot-messages .connect-to-live').forEach(el => el.remove());
            const messageHtml = `
            <div class="chatbot-message bot">
                <div class="chatbot-message-content-bot">
                    <p>Unfortunately, no one is available to chat right now. Your ticket has been created, and you will be contacted once someone has updates about your issue.</p>
                </div>
                <div class="chatbot-message-time">${new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}</div>
            </div>`;
            document.querySelector('.chatbot-messages').insertAdjacentHTML('beforeend', messageHtml);
            self.isLiveChat = false;
        }, 60000);

    }


    sendLiveChatMessage() {
        console.log('message send');
        const inputElement = document.querySelector('.chatbot-input');
        const message = inputElement.value.trim();

        if (guestEmail && receiverEmail && message) {
            const messageHtml = `
            <div class="chatbot-message user">
                <div class="chatbot-message-content-user">
                    <p>${message}</p>
                </div>
                <div class="chatbot-message-time">${new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}</div>
            </div>`;

            document.querySelector('.chatbot-messages').insertAdjacentHTML('beforeend', messageHtml);
            this.scrollToBottomLive();

            // Send the message via SignalR
            connection.invoke("SendPrivateMessage", guestEmail, receiverEmail, message)
                .catch(function (err) {
                    console.error(err.toString());
                });

            inputElement.value = '';
        }
    }

    scrollToBottomLive() {
        const container = document.querySelector(".chatbot-messages");
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    }


}



